import axios from "axios";
import { celebApi } from "./api";

export async function newRecommendationQuiz(
  recommendationData: any,
  userToken: string
) {
  const httpOptions = {
    headers: {
      Authorization: userToken,
    },
  };

  return axios
    .post(
      `${celebApi}/user/createRecommendationQuiz`,
      { recommendationData },
      httpOptions
    )
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error;
    });
}

export async function fetchRecommnedationQuiz(status: boolean) {
  return axios
    .get(`${celebApi}/admin/getRecommendationQuiz?status=${status}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      throw error;
    });
}
